<template>
    <el-col :span="24" class="toolbar" :class="moreOpt?'toolbar_open':'toolbar_collapse'">
      <el-form :label-position="labelPosition"   :label-width="labelWidth"     @keyup.enter.native="handlerSubmit">
        <el-col :span="22">
          <slot>
            只有在没有要分发的内容时才会显示。
          </slot>
        </el-col>
        <el-col :span="2" style="padding: 10px 10px 0px 0px;text-align: right">
          <i class="el-icon-arrow-down" :class="moreOpt?'fa-angle-double-up':'fa-angle-double-down'"
             v-bind:style="{display: (moreDisplay?'inline-block':'none')}" @click="moreOpt=!moreOpt"
             style="cursor: pointer">
            <el-button size="mini" type="warning" round>{{moreOpt?'折叠':'展开'}}</el-button>
          </i>
        </el-col>
      </el-form>
    </el-col>

</template>

<script>

  export default {
    data () {
      return {
        moreOpt: false
      };
    },
    props: {
       submit:{
          type:Function,
          default: function noop(){
          }
       },
      // 判断是否就是打开的
      isOpen:{
        type:Boolean,
        default:false
      },
      moreDisplay: {
        type: Boolean
      },
      labelWidth: {
        default: '100px'
      },
      labelPosition: {
        default: 'right'
      },
    },
    methods:{
      handlerSubmit(){
        this.submit();
      }
    }
  };
</script>

<style lang="less">
  .toolbar {
    background: #f2f2f2;
    padding: 10px;
    overflow: hidden;
    margin: 0px 0px 10px 0px;
    .el-date-editor, .el-select, .el-input {
      width: 100%;
    }
    .el-form-item {
      margin: 0 0 6px 0;
      .el-form-item__label {
        margin-right: 0;
        padding: 0px 5px 2px 0px;
      }
    }
  }

  .toolbar_collapse {
    height: 55px;
    position: relative;
    overflow: hidden;
    transition: height 0.6s;
  }

  .toolbar_open {
    transition: height 0.6s ease;
  }
</style>



// WEBPACK FOOTER //
// src/components/SearchBar/SearchBar.vue